import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Router from "./components/Router/Router";

function App() {

  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
